import { OrcamentoClientInheritance } from './orcamentoClientInheritance';

// Allergan (D-0152, Rafael 31/10): segue as regras de FEE da AbbVie sem virar modelo `abbvie`.
// Orçamento já aprovado pelo cliente mantém o FEE gravado: a tela não recalcula nem pede a tabela.
// Espelho de App\Services\OrcamentoAllerganFeePolicy (API).
export const MODELO_ALLERGAN = 'allergan';

export function ehClienteAllergan(cliente) {
    if (!cliente || typeof cliente !== 'object') return false;
    return OrcamentoClientInheritance.resolveVisualModel(cliente) === MODELO_ALLERGAN;
}

export function mantemFeeGravado({ cliente, dataAprovacaoCliente, id, copiar } = {}) {
    return Boolean(id) && !copiar && Boolean(dataAprovacaoCliente) && ehClienteAllergan(cliente);
}

export const AllerganFeePolicy = { ehClienteAllergan, mantemFeeGravado };
